import React from 'react';
import styled from 'styled-components';
import { Label, Block } from '../..';
import constants from '../../../../core/constants';

interface Props {
  isToday?: boolean;
  dayNameOfWeek?: string;
  dayNumberOfWeek?: string;
  percent: number;
  onClick: () => void;
  isSelected: boolean;
}

const SingleDayWeekElement = styled.div.attrs((props: any) => ({
  percent: props.percent,
  isToday: props.isToday
}))`
  width: ${(props: any) => props.percent}%;
  min-height: 40px;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: visible;
  text-align: center;
  div {
    height: 26px;
    width: 26px;
    display: block;
    line-height: 26px;
    text-align: center;
    border-radius: 50%;
    margin: 0 auto;
  }

  .active {
    background: var(--text-primary);
    color: #fff;
    font-weight: 900;
  }

  .active2 {
    background: var(--background-background02);
    color: var(--text-primary);
  }

  .textDay {
    font-size: 12px;
  }

  @media (min-width: ${constants.BREAKPOINT_SIZE}px) {
    box-shadow: ${(props) =>
      props.isToday ? '-1px -2px 27px -14px #c7c7c7' : 'none'};
    background-color: ${(props) => (props.isToday ? '#fff' : 'none')};
    display: flex;
    border-bottom: 1px solid var(--background-background-disabled);
    &:before {
      content: '';
      width: 1px;
      height: 54px;
      display: block;
      background: var(--background-background-disabled);
      position: absolute;
      top: 0px;
      left: 0px;
    }
    div {
      margin: 0px;
      margin-left: 2px;
    }
    .active {
      margin-left: 7px;
    }
    .textDay {
      font-size: 14px;
    }
  }
`;
function SingleDayWeek(props: Readonly<Props>) {
  const {
    dayNameOfWeek,
    dayNumberOfWeek,
    isToday,
    percent,
    onClick,
    isSelected
  } = props;
  let labelNameColor = '';
  let labelNumberColor = '';
  let divClass = '';
  if (isToday) {
    labelNameColor = 'var(--text-primary)';
    divClass = 'active';
    labelNumberColor = '#fff';
  } else if (isSelected) {
    labelNameColor = 'var(--text-primary)';
    divClass = 'active2';
    labelNumberColor = 'var(--text-primary)';
  } else {
    labelNameColor = 'var(--text-text02)';
    divClass = '';
    labelNumberColor = 'var(--text-text02)';
  }
  return (
    <SingleDayWeekElement percent={percent} isToday={isToday} onClick={onClick}>
      <>
        {dayNameOfWeek && dayNumberOfWeek ? (
          <>
            <Label
              bold={isToday}
              color={labelNameColor}
              text={dayNameOfWeek}
              className="textDay"
            />
            <Block className={divClass}>
              <Label
                color={labelNumberColor}
                text={dayNumberOfWeek}
                lineHeight={26}
                className="textDay"
              />
            </Block>
          </>
        ) : (
          <Block />
        )}
      </>
    </SingleDayWeekElement>
  );
}

SingleDayWeek.defaultProps = {
  isToday: false,
  dayNameOfWeek: '',
  dayNumberOfWeek: ''
};

export default SingleDayWeek;
